import { useDispatch, useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";
import GoalsData from "./GoalsData";
import { deleteGoal, getGoalsSuccess } from "../../store/slices/GoalsSlice";
import { start } from "../../store/slices/GoalsSlice";
import { useEffect, useState } from "react";
import DeleteModal from "../Modals/DeleteModal";
import { remove } from "../../services/upload-files.service";
import { Link } from "react-router-dom";
import Permission from "../RoleManagement/Permission";

export default function Goal() {
  const [show, setShow] = useState(false);
  const [goalId, setGoalId] = useState(null);
  const dispatch = useDispatch();
  const { data } = useFetch("templates/data");
  const [searchTerm, setSearchTerm] = useState("");
  const goalsData = useSelector((state) => state.goals.data.goalsdata);

  useEffect(() => {
    if (data) {
      dispatch(getGoalsSuccess(data));
    } else {
      dispatch(start());
    }
  }, [data, dispatch]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Filter goals data based on search term
  const filteredData = goalsData
    ? goalsData.filter((goal) =>
        goal.goal_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        goal.category.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];

  const handleDeleteResponse = (response) => {
    setShow(false);
    if (goalId && response) {
      dispatch(start());
      remove(`templates/form/${goalId}`).then((res) => {
        if (res) {
          dispatch(deleteGoal(goalId));
        }
      });
    }
  };

  return (
    <>
      <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          <h1 className="h2">Total Goal Created</h1>
        </div>

        {/* Row for Search and Create Goal Button */}
        <div className="row mb-3 align-items-center">
          <div className="col-md-6">
            <div className="position-relative">
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={handleSearchChange}
                className="form-control"
              />
              <span className="fa fa-search department-search-icon"></span>
            </div>
          </div>
          <div className="col-md-6 text-end">
            <Permission access={"/creategoal"}>
               <Link to="/creategoal">
                <button className="btn btn-primary btn-add">
                 
                  <i className="fa-regular fa-square-plus"></i> Create Goal
                  
                </button>
             </Link>
            </Permission>
          </div>
        </div>

        {/* Goals Table */}
        <table className="table">
          <thead>
            <tr>
              <th>Goal Name</th>
              <th>Category</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Status</th>
              <th>%Complete</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <GoalsData
              setShow={setShow}
              setGoalId={setGoalId}
              searchTerm={searchTerm}
              filteredData={filteredData}
            />
          </tbody>
        </table>

        {/* Delete Confirmation Modal */}
        <DeleteModal
          handleDeleteResponse={handleDeleteResponse}
          show={show}
          title={"Goal"}
        />
      </main>
    </>
  );
}
